// External links used across the app
export const WORD_ADDIN_MARKETPLACE_URL = 'https://marketplace.microsoft.com/en-us/product/office/WA200008746';
